module.exports = __webpack_public_path__ + "img/logo.2573b7c4.png";